import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { Field, reduxForm, change } from "redux-form";
import {
  Tooltip,
  Alert,
  Input as AInput,
  DatePicker,
  Select,
  Form,
} from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { fetchAddresses, minAgeForSignUp } from "../../../theme-variables";
import { getConfig } from "../../../actions/appConfigActions";
import Input from "../../form-components/Input";
import Checkbox from "../../form-components/Checkbox";
import Button from "../../form-components/Button";
import { makeField } from "../../form-components/makeComponent";
import "./SignUpForm.scss";
import { withTranslation } from "react-i18next";
import countries from "../../../helpers/countries";
import i18next from "i18next";

class SignUpForm extends React.Component {
  state = { day: null, month: null, year: null };
  onSubmit = (formValues) => {
    this.props.onSubmit(formValues);
  };
  changeBirthdayDate = (val, name) => {
    let newState = this.state;
    newState[name] = val;
    this.setState(newState);
    const birthday = `${newState.year}-${newState.month}-${newState.day}`;
    this.props.dispatch(change("signUpForm", "birthday", moment(birthday)));
  };
  renderCountryCodeSelect = ({
    input,
    placeholder,
    meta,
    prefix,
    suffix,
    required,
    ...rest
  }) => {
    const error = meta.touched && meta.error !== null ? meta.error : null;
    return (
      <Form.Item
        className={`teapp-select-wrapper ${required ? "required" : ""}`}
        colon
        help={error ? this.props.t(error) : null}
        onBlur={() => {
          input.onBlur(input.value);
        }}
        validateStatus={error ? "error" : null}
        hasFeedback
        {...rest}
      >
        <Select
          allowClear
          showSearch
          placeholder={placeholder}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          {...input}
          dropdownMatchSelectWidth={false}
        >
          {countries.map((v) => (
            <Select.Option key={v.code} value={v.code}>
              {v.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    );
  };
  render() {
    const { loading, error } = this.props.signUpState;
    const { t, anyTouched } = this.props;
    return (
      <form
        className="signup-form"
        onSubmit={this.props.handleSubmit(this.onSubmit)}
      >
        <Field
          name="email"
          component={Input}
          required={true}
          placeholder={t("form.placeholder.email")}
          type="email"
          suffix={<MailOutlined className="site-form-item-icon" />}
        />
        <Field
          name="firstname"
          component={Input}
          required={true}
          placeholder={t("form.placeholder.name")}
        />
        <Field
          name="lastname"
          component={Input}
          required={true}
          placeholder={t("form.placeholder.lastname")}
        />
        <Field
          name="password"
          component={Input}
          required={true}
          placeholder={t("form.placeholder.passwd")}
          type="password"
          suffix={
            <Tooltip
              style={{ margin: "0 8px", color: "blue" }}
              title={t("form.tooltip.passwd")}
            >
              <LockOutlined className="site-form-item-icon" />
            </Tooltip>
          }
        />
        <Field
          name="repeatpassword"
          component={Input}
          required={true}
          placeholder={t("form.placeholder.repeat_passwd")}
          type="password"
          suffix={<LockOutlined className="site-form-item-icon" />}
        />
        {fetchAddresses ? (
          <label>
            {t("form.label.address")}:
            <Field
              name="street"
              component={Input}
              required={true}
              placeholder={t("form.placeholder.street")}
            />
            <AInput.Group compact>
              <Field
                name="city"
                component={Input}
                style={{ width: "49%", marginRight: "2%" }}
                required={true}
                placeholder={t("form.placeholder.city")}
              />
              <Field
                name="state"
                component={Input}
                style={{ width: "49%" }}
                required={true}
                placeholder={t("form.placeholder.state")}
              />
            </AInput.Group>
            <AInput.Group compact>
              <Field
                name="postal_code"
                component={Input}
                style={{ width: "49%", marginRight: "2%" }}
                required={true}
                placeholder={t("form.placeholder.postal_code")}
              />
              <Field
                name="country_code"
                component={this.renderCountryCodeSelect}
                style={{ width: "49%" }}
                onChange={(v) => {
                  this.props.dispatch(change("signUpForm", "country_code", v));
                }}
                required={true}
                placeholder={t("form.placeholder.country_code")}
              />
            </AInput.Group>
          </label>
        ) : (
          <label>
            {t("form.placeholder.country_code")}:
            <Field
              name="country_code"
              component={this.renderCountryCodeSelect}
              style={{ width: "49%", marginTop: 5 }}
              onChange={(v) => {
                this.props.dispatch(change("signUpForm", "country_code", v));
              }}
              required={true}
              placeholder={t("form.placeholder.country_code")}
            />
          </label>
        )}
        <label>
          {t("form.label.birthdate")}:
          <AInput.Group compact>
            <AInput
              placeholder={t("form.placeholder.dd")}
              maxLength={2}
              value={this.state.day}
              style={{ width: 45 }}
              onChange={(e) => {
                this.changeBirthdayDate(e.target.value, "day");
              }}
            />
            <AInput
              placeholder="–"
              style={{
                width: 8,
                border: "none",
                padding: "5.9px 0 0",
                background: "none",
              }}
              disabled
            />
            <AInput
              placeholder={t("form.placeholder.mm")}
              maxLength={2}
              value={this.state.month}
              style={{ width: 48 }}
              onChange={(e) => {
                this.changeBirthdayDate(e.target.value, "month");
              }}
            />
            <AInput
              placeholder="–"
              style={{
                width: 8,
                border: "none",
                padding: "5.9px 0 0",
                background: "none",
              }}
              disabled
            />
            <AInput
              placeholder={t("form.placeholder.yyyy")}
              value={this.state.year}
              maxLength={4}
              style={{ width: 66 }}
              onChange={(e) => {
                this.changeBirthdayDate(e.target.value, "year");
              }}
            />
          </AInput.Group>
        </label>
        <Field
          className="datePicker"
          name="birthday"
          component={makeField(DatePicker, "DD.MM.YYYY", true)}
          placeholder={t("form.label.birthdate")}
          hasFeedback
          onFocus={(e) => e.preventDefault()}
          onBlur={(e) => e.preventDefault()}
        />
        <div className="checkbox-group">
          <Field
            name="mailing"
            component={Checkbox}
            type="checkbox"
            label={t("signup.mailing")}
          />
          <Field
            name="tos"
            component={Checkbox}
            type="checkbox"
            label={
              !this.props.loading
                ? `${t("signup.tos_aggre")} <a href='${
                    this.props.regulations_page || "/regulamin"
                  }' rel='noopener noreferrer' target='_blank'>${t(
                    "signup.tos_regulations"
                  )}</a> ${t("signup.tos_and")} <a href='${
                    this.props.policy_page || "/polityka"
                  }' rel='noopener noreferrer' target='_blank'>${t(
                    "signup.tos_policy"
                  )}</a>.`
                : `${t(
                    "signup.tos_aggre"
                  )} <a href='/regulamin' rel='noopener noreferrer' target='_blank'>${t(
                    "signup.tos_regulations"
                  )}</a> ${t(
                    "signup.tos_and"
                  )} <a href='/polityka'}' rel='noopener noreferrer' target='_blank'>${t(
                    "signup.tos_policy"
                  )}</a>.`
            }
          />
        </div>
        {anyTouched && error ? (
          <>
            <Alert type="error" message={error} showIcon />
            <br />
          </>
        ) : null}
        <Button
          type="primary"
          htmlType="submit"
          loading={loading ? true : false}
        >
          {t("signup.title")}
        </Button>
      </form>
    );
  }
}

const validate = (formValues) => {
  const errors = {};
  if (!formValues.email) errors.email = "form.validate.required";
  if (!formValues.password) errors.password = "form.validate.required";
  if (!formValues.repeatpassword)
    errors.repeatpassword = "form.validate.required";
  if (!formValues.firstname) errors.firstname = "form.validate.required";
  if (!formValues.lastname) errors.lastname = "form.validate.required";
  if (!formValues.birthday) errors.birthday = "form.validate.required";

  if (!formValues.tos) errors.tos = true;

  if (!/^[a-zA-ZzżźćńółęąśŻŹĆĄŚĘŁÓŃ\-—–\s]*$/.test(formValues.firstname))
    errors.firstname = "form.validate.special_chars";
  if (!/^[a-zA-ZzżźćńółęąśŻŹĆĄŚĘŁÓŃ\-—–\s]*$/.test(formValues.lastname))
    errors.lastname = "form.validate.special_chars";

  if (
    !/^[A-Za-zzżźćńółęąśŻŹĆĄŚĘŁÓŃ\d@^()_\-$#!%*?&]{8,}$/.test(
      formValues.password
    )
  )
    errors.password = "form.validate.passwd";

  if (formValues.password !== formValues.repeatpassword)
    errors.repeatpassword = "form.validate.passwdmatch";

  if (
    !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      formValues.email
    )
  )
    errors.email = "form.validate.email";

  if (formValues.birthday === null || !moment(formValues.birthday).isValid())
    errors.birthday = "form.validate.date";
  else if (
    minAgeForSignUp &&
    moment().diff(formValues.birthday, "years") < minAgeForSignUp
  )
    errors.birthday = `${i18next.t(
      "signup.min_age"
    )}${minAgeForSignUp}${i18next.t("signup.min_age_2")}`;

  if (fetchAddresses) {
    if (!formValues.postal_code) errors.postal_code = "form.validate.required";
    if (!formValues.city) errors.city = "form.validate.required";
    if (!formValues.state) errors.state = "form.validate.required";
    if (!formValues.street) errors.street = "form.validate.required";
    if (
      formValues.postal_code &&
      (formValues.postal_code.length > 10 ||
        /<[a-z/][\s\S]*>/.test(formValues.postal_code))
    )
      errors.postal_code = "form.validate.wrong_input_max10";
    if (
      formValues.city &&
      (formValues.city.length > 30 || /<[a-z/][\s\S]*>/.test(formValues.city))
    )
      errors.city = "form.validate.wrong_input_max30";
    if (
      formValues.state &&
      (formValues.state.length > 30 || /<[a-z/][\s\S]*>/.test(formValues.state))
    )
      errors.state = "form.validate.wrong_input_max30";
  }

  if (!formValues.country_code) errors.country_code = "form.validate.required";
  if (
    formValues.country_code &&
    (formValues.country_code.length > 2 ||
      /<[a-z/][\s\S]*>/.test(formValues.country_code))
  )
    errors.country_code = "form.validate.wrong_input_max2";

  return errors;
};

const mapStateToProps = (state) => {
  return {
    config: state.appConfig.config,
    loading: state.appConfig.loading,
  };
};

SignUpForm = connect(mapStateToProps, { getConfig })(SignUpForm);

export default withTranslation()(
  reduxForm({ form: "signUpForm", validate })(SignUpForm)
);
